export default __webpack_public_path__ + "static/home-bg2-9ad58d1665de0ddff8de4928837a14f1.jpg";